import { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { checkForClassName } from '../assertLib';

const ProjectPermission = ({
  active,
  allowedToConfigure,
  clickableClass,
  disabled,
  isChecked,
  isFetching,
  permissionId,
  permissionInfo,
  permissionName,
  permissionsToggle,
  result,
  setCurrentStepResult,
  setPermissionsToggle,
}) => {
  useEffect(() => {
    if (active && result?.loading === true) setCurrentStepResult({ ...result, loading: isFetching });
  }, [active, isFetching, result, setCurrentStepResult]);

  const className = checkForClassName(allowedToConfigure, disabled, clickableClass);
  return active && (
    <Form.Group className="rax-mgcp-permissions-grid">
      <Form.Label htmlFor={permissionId} className={className}>{ permissionName }</Form.Label>
      <Form.Check
        id={permissionId}
        key={permissionId}
        className="form-switch-lg"
        aria-label={permissionId}
        type="switch"
        name={permissionName}
        checked={allowedToConfigure && isChecked}
        disabled={!allowedToConfigure || disabled}
        onChange={(e) => {
          setPermissionsToggle({ ...permissionsToggle, [permissionName]: !isChecked });
          setCurrentStepResult({
            roles: { ...result.roles, [e.target.name]: e.target.checked },
            constraints: { ...result.constraints },
            loading: isFetching,
          });
        }}
      />
      <Form.Text className="text-muted">{ permissionInfo() }</Form.Text>
    </Form.Group>
  );
};

export default ProjectPermission;
